<template>
    <Page :is-loading="isPageLoading" :page-code="pageCode" @reload="loadPage">
        <div class="page-body">
            <Panel v-if="orderDetail.goods">
                <span slot="title">
                    <i class="iconfont icon-doctoral-cap fs20px top2px" /> {{orderDetail.goods.name}}
                </span>
                <div class="lh2em bottom-line">{{orderDetail.goods.description}}</div>
                <div class="mb-1rem">
                    <GoodsCard :goods="orderDetail.goods" :coinExchange="orderDetail.mideCoinExchange"/>
                    <StudentCard :order="orderDetail" />
                </div>
            </Panel>
            <Panel>
                <span slot="title">
                    <i class="iconfont icon-heart-plus fs20px top2px" /> 编程课服务号
                </span>
                <div class="mide-qr-code lh1_8em flex-column flex-x-center flex-y-center">
                    <p>查看编程课课表</p>
                    <p>获取编程课内容、编程作品及作业</p>
                    <a href="/images/mide-qr-code.jpg">
                        <img class="qr-code" src="/images/mide-qr-code.jpg"  alt=""/>
                    </a>
                    <p v-if="isWxBrowser">请长按二维码前往公众号并关注</p>
                    <p v-else>微信扫描二维码前往公众号并关注</p>
                    <p>米德编程服务中心</p>
                </div>
            </Panel>
            <Help link="/user-doc/交费详情/index.html">
                <span v-if="isWxBrowser">长按二维码前往公众号并关注</span>
                <span v-else>微信扫描二维码前往公众号并关注</span>
            </Help>
        </div>
    </Page>
</template>

<script>
    import Page from '../../../../components/Page.vue';
    import Panel from '../../../../components/Panel.vue';
    import Help from '../../../../components/Help.vue';
    import GoodsCard from '../../components/GoodsCard.vue';
    import StudentCard from '../../components/StudentCard.vue';
    import PageLoading from '../../../../mixins/PageLoading';
    import WxPreparing from '../../../../mixins/WxPreparing';

    export default {
        name: 'OrderMasterDetail',
        components: {
            Page, Panel, Help, GoodsCard, StudentCard,
        },
        mixins: [PageLoading, WxPreparing],
        data() {
            return {
                orderDetail: {},
            };
        },
        async mounted() {
            await this.loadPage();
            await this.hideWxAllMenuItems();
        },
        methods: {
            async loadPageData() {
                const { studentUuid, goodsUuid, coin } = this.$route.query;
                const res = await this.$api.orderMaster.goodsDetails(studentUuid, goodsUuid);
                this.orderDetail = res.data.data;
                this.orderDetail.goods.coin = coin || 0;
                this.orderDetail.student.coin = coin || 0;
            },
        },
    };
</script>

<style scoped lang="less">
    .qr-code {
        width: 38vw;
        display: block;
        margin: 5px 0;
    }
</style>
